module.exports = __webpack_public_path__ + "static/media/ktc.c4c3a2a6.c4c3a2a6.jpg";